/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownInteractionCategory } from '../models/db_DropdownInteractionCategory';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InteractionCategories {
    /**
     * Get a list of interaction categories
     * @returns db_DropdownInteractionCategory OK
     * @throws ApiError
     */
    public static listInteractionCategories(): CancelablePromise<Array<db_DropdownInteractionCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/interaction-categories',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
